import { Channel, User } from 'stream-chat';
import { client, getIsOrganizerToken } from '@bizzabo/entities';

// This method is client only and will work for 100 first users
export const isUserModeratorOnThisChannel = (channel: Channel, user: User) => {
    return channel.state.members[user.id]?.channel_role === 'channel_moderator';
};

// this method will query for specific user from server
export const getMemberFromUserOnChannel = (channel: Channel, user: User) => {
    return channel.queryMembers({ id: user.id });
};

export const banUser = (accountId, eventId, sessionId, userId) => {
    return banUnbanUser(accountId, eventId, sessionId, userId, 'BAN');
};

export const unBanUser = (accountId, eventId, sessionId, userId) => {
    return banUnbanUser(accountId, eventId, sessionId, userId, 'UNBAN');
};

const banUnbanUser = (
    accountId: number,
    eventId: number,
    sessionId: number,
    userId: string,
    commandType: 'BAN' | 'UNBAN'
) => {
    let url = `/api/v2/agenda/events/${eventId}/sessions/${sessionId}/moderations`;
    const portalUrl = `/api/v2/agenda/accounts/${accountId}/portals/${eventId}/sessions/${sessionId}/chat/moderation`;

    if (getIsOrganizerToken()) {
        url = portalUrl;
    }

    return client().post(url, {
        providerUserIds: [userId],
        provider: 'GET_STREAM',
        command: commandType,
    });
};
